<template>
  <BusinessList
    :tabPanelData="tabList"
    pageTypeIn="RECEIVED"
    :marketFeeCanCommand="false"
    :canCommand="false"
    :FilterFieldProps="FilterField"
    businessTypeName="TABLE_RECEIVED_BUSINESS"
    :HiddenFieldFunProps="(item:any) => '开票状态、开票日期、发票号码、发票金额、紧急程度、预计完成天数、维修类型、业务分类'.split('、').some(fieldName => fieldName === item.fieldName)"
  />
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs } from 'vue'
import BusinessList from '@/views/business/businessList/components/BusinessTable.vue'
import { FilterField } from './FilterField'

export default defineComponent({
  name: 'Receivedbusiness',
  components: {
    BusinessList
  },
  setup() {
    const dataMap = reactive({
      tabList: [
        { name: '联系人', id: 1 }
        // { name: '市场费', id: 4 },
        // { name: '跟踪信息', id: 3 }
      ],
      FilterField
    })
    return { ...toRefs(dataMap) }
  }
})
</script>
